import cx from "classnames";
import React from "react";
import { FormattedMessage } from "react-intl";
import * as Collapsible from "@radix-ui/react-collapsible";
import { Paragraph } from "@trainline/depot-web";
import { spacers } from "@trainline/depot-web/css";
import IconChevron from "../../../assets/icons/IconChevron";
import IconTrackPath from "../../../assets/icons/IconTrackPath";
import useJourneyContext from "../../../hooks/useJourneyContext";
import useJourneyLeg from "../../../hooks/useJourneyLeg";
import useTSIIntermediateCallingPoints from "../../../hooks/useTSIIntermediateCallingPoints";
import getLegDuration from "../../../utils/legs/getLegDuration";
import getTSIViewStopsToggleMessagesByType from "../../../utils/TSI/getTSIViewStopsToggleMessagesByType";
import FormattedDuration from "../../FormattedDuration";
import LoadingSkeleton from "../../LoadingSkeleton";
import TrackItem from "../../TrackItem";
import * as s from "./CollapsibleCallingPoints.module.css";
import IntermediateCallingPoint from "./IntermediateCallingPoint";
const CollapsibleCallingPoints = ({ legId, type }) => {
  var _a, _b;
  const leg = useJourneyLeg(legId);
  const transportType = ((_a = leg == null ? void 0 : leg.transportMode) == null ? void 0 : _a.mode) || (leg == null ? void 0 : leg.transportModeName);
  const getMessageId = getTSIViewStopsToggleMessagesByType(type);
  const callingPoints = useTSIIntermediateCallingPoints(legId);
  const hasTSIData = callingPoints !== void 0;
  const hasIntermediatePoints = ((_b = callingPoints == null ? void 0 : callingPoints.length) != null ? _b : 0) > 0;
  const { isInitializing } = useJourneyContext();
  const disabled = !hasTSIData || !hasIntermediatePoints || isInitializing;
  return /* @__PURE__ */ React.createElement(Collapsible.Root, {
    className: s.root
  }, /* @__PURE__ */ React.createElement(TrackItem, {
    style: { padding: `${spacers.dp_s24} 0` }
  }, /* @__PURE__ */ React.createElement(TrackItem.Marker, null, /* @__PURE__ */ React.createElement(IconTrackPath, null)), /* @__PURE__ */ React.createElement(TrackItem.Time, null, /* @__PURE__ */ React.createElement(Paragraph, {
    as: "span",
    color: "disabled"
  }, /* @__PURE__ */ React.createElement(FormattedDuration, {
    value: getLegDuration(leg)
  }))), /* @__PURE__ */ React.createElement(TrackItem.Info, null, /* @__PURE__ */ React.createElement(Collapsible.Trigger, {
    asChild: true,
    disabled,
    className: s.trigger
  }, /* @__PURE__ */ React.createElement(Paragraph, {
    as: "button"
  }, isInitializing ? /* @__PURE__ */ React.createElement(LoadingSkeleton, {
    style: { width: "125px" }
  }, "A") : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("span", {
    className: cx(s.message, s.open)
  }, /* @__PURE__ */ React.createElement(FormattedMessage, {
    id: getMessageId(true, hasTSIData, hasIntermediatePoints, transportType)
  })), /* @__PURE__ */ React.createElement("span", {
    className: cx(s.message, s.close)
  }, /* @__PURE__ */ React.createElement(FormattedMessage, {
    id: getMessageId(false, hasTSIData, hasIntermediatePoints, transportType)
  })), hasIntermediatePoints && /* @__PURE__ */ React.createElement(IconChevron, {
    className: s.chevron
  })))))), /* @__PURE__ */ React.createElement(Collapsible.Content, {
    className: s.content
  }, callingPoints == null ? void 0 : callingPoints.map((point) => /* @__PURE__ */ React.createElement(IntermediateCallingPoint, {
    callingPoint: point,
    key: point.index
  }))));
};
var CollapsibleCallingPoints_default = CollapsibleCallingPoints;
export {
  CollapsibleCallingPoints_default as default
};
